export const authConfigs = {
  signInRedirectURL: window?.config?.SIGN_IN_REDIRECT_URL,
  signOutRedirectURL: window?.config?.SIGN_OUT_REDIRECT_URL,
  clientID: window?.config?.CLIENT_ID,
  baseUrl: window?.config?.ASGARDEO_BASE_URL,
  scope: window?.config?.SCOPE,
  appAdminRole: window?.config?.APP_ADMIN_ROLE
};
